
<template>
  <div id='stiff'>
    <svg id='svgStiff' height='460px'>
    </svg>
  </div>
</template>
<script>
/* globals window, requestAnimationFrame */
import * as d3 from 'd3'
import {db, fbPaths} from '../../firebase/firebase'
import {svgResizer} from '../mixins/svgResizer'
export default {
  name: 'vue-stiff-diagram',
  mixins: [svgResizer],
  data () {
    return {
      clientWidth: 300,
      clientHeight: 460,
      line: '',
      textBufferX: 40,
      textBufferY: 5,
      selectedWell: '',
      wells: {}
    }
  },
  firebase: {
    // wells: {
    //   source: fireFetch.chemistry('11223344', 'well-1'),
    //   asObject: true,
    //   readyCallback: function () {
    //     if (Object.keys(this.$route.query).length !== 0) {
    //       this.selectedWell = this.$route.query['wellkey']
    //     }
    //   }
    // }
    wells: {
      source: db.ref(fbPaths.waterChemistry),
      asObject: true,
      readyCallback: function () {
        console.log('callback')
        if (Object.keys(this.$route.query).length !== 0) {
          this.selectedWell = this.$route.query['wellkey']
        }
      },
      cancelCallback: function (error) {
        console.log(error)
      }
    }
  },
  computed: {
    polyChem: function () {
      return [
        { 'label': 'Na', 'x': -(this.chemCalc('na', this.ions.na) + this.chemCalc('k', this.ions.k)), 'y': 0 },
        { 'label': 'Ca2', 'x': -(this.chemCalc('ca2', this.ions.ca2)), 'y': 1 },
        { 'label': 'Mg2', 'x': -(this.chemCalc('mg2', this.ions.mg2)), 'y': 2 },
        { 'label': 'SO4', 'x': this.chemCalc('so4', this.ions.so4), 'y': 2 },
        { 'label': 'HCO3', 'x': this.chemCalc('hco3', this.ions.hco3), 'y': 1 },
        { 'label': 'Cl', 'x': this.chemCalc('cl', this.ions.cl), 'y': 0 }
      ]
    },
    ions: function () {
      if (this.selectedWell === '') {
        return {
          'ca2': 0.001,
          'mg2': 0.001,
          'na': 0.001,
          'k': 0.001,
          'hco3': 0.001,
          'so4': 0.001,
          'cl': 0.001,
          'no3': 0.001
        }
      } else {
        return this.wells[this.selectedWell]
      }
    }
  },
  watch: {
    polyChem: function () {
      d3.select('#svgStiff')
      .select('#stiff-line')
      .transition()
      .duration(750)
      .attr('d', this.line(this.polyChem))

      d3.selectAll('.chemLabels')
      .data(this.polyChem)
      .transition()
      .duration(750)
      .attr('transform', d => this.trans(d, this.getScales(), this.textBufferX, this.textBufferY))

      d3.selectAll('#chemValue')
      .data(this.polyChem)
      .transition()
      .duration(750)
      .tween('text', function (d) {
        var node = this
        var i = d3.interpolate(this.textContent, d.x)
        return function (t) {
          d3.select(node).text(i(t) < 0 ? -i(t).toFixed(2) : i(t).toFixed(2))
        }
      })
    },
    '$route.query' (to, from) {
      this.selectedWell = to['wellkey']
    }
  },
  methods: {
    trans (d, scale, bufx, bufy) {
      let buf = d.x > 0 ? bufx : -bufx
      return 'translate(' + (scale.x(d.x) + buf) + ', ' + (scale.y(d.y) + bufy) + ')'
    },
    getScales () {
      const x = d3.scaleLinear()
                  .domain([-10, 10])
                  .range([5, this.clientWidth - 10])
      const y = d3.scaleLinear()
                   .domain([0, 2])
                   .range([5, this.clientHeight - 50])
      return { x, y }
    },
    breakDownVisualization () {
      d3.select('#svgStiff').select('g').remove()
      d3.select('#svgStiff').select('#xaxis').remove()
      d3.select('#svgStiff').select('path').remove()
      d3.select('#svgStiff').selectAll('text').remove()
    },
    setUpVisualization () {
      const scale = this.getScales()
      this.line = d3.line()
        .x((d) => scale.x(d.x))
        .y((d) => scale.y(d.y))
        .curve(d3.curveLinearClosed)
      let xAxis = d3.axisBottom().scale(scale.x)
      d3.select('#svgStiff')
        .attr('width', this.clientWidth)
        .append('g')
        .attr('id', 'xaxis')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + (this.clientHeight - 25) + ')')
        .call(xAxis)
      d3.select('#svgStiff')
        .append('g')
        .selectAll('text')
        .data(this.polyChem)
        .enter()
        .append('text')
        .attr('class', 'chemLabels')
        .attr('transform', d => this.trans(d, this.getScales(), this.textBufferX, this.textBufferY))
        .attr('text-anchor', function (d) { return d.x > 0 ? 'end' : 'start' })
        .text(function (d) { return d.label })
        .append('tspan')
        .attr('id', 'chemValue')
        .attr('x', '.5em')
        .attr('dy', '1em')
        .text(function (d) { return d.x < 0 ? -d.x.toFixed(2) : d.x.toFixed(2) })

      d3.select('#svgStiff').append('path')
        .datum(this.polyChem)
        .attr('id', 'stiff-line')
        .attr('class', 'line')
        .attr('class', 'data-line')
        .attr('d', this.line)
        .attr('stroke-width', 2)
        .attr('fill', 'none')
    },
    chemCalc (type, mgL) {
      const mgmeq = {
        'ca2': 20.1,
        'mg2': 12.2,
        'na': 23.0,
        'k': 39.1,
        'hco3': 61.0,
        'so4': 48.1,
        'cl': 35.5,
        'no3': 62.0
      }
      return mgL / mgmeq[type]
    }
  }
}
</script>
<style>
.data-line {
  stroke-width: 1;
  stroke: black;
}
</style>



// WEBPACK FOOTER //
// src/components/visualization/StiffDiagram.vue